import React, { Fragment } from 'react';
import { object, bool, func, string, array, oneOfType } from 'prop-types';
import moment from 'moment';

import { Title } from '../styled-components';
import { TaskForm } from './task-form';
import { TaskDetails } from './task-details';
import { SpinnerWithBackground } from '../../components/ui-helpers';
import RequestClients from '../../components/request-clients';

export const TasksModal = ({
  form,
  task,
  modalTitle,
  isLoading,
  isUpdating,
  title,
  description,
  taskPriority,
  status,
  dueDate,
  dueTime,
  type,
  users,
  onSave,
  onClose,
  selectedUser,
  setSelectedUser,
  isShowContacts,
  isWithoutRequest,
  searchedRequests,
  selectedRequest,
  isFetchingRequests,
  setSelectedRequest,
  setRequestsData,
  handleRequestSearch,
  onToggleShowContacts,
}) => (
  <Fragment>
    {isLoading && <SpinnerWithBackground />}

    <Title>{type === 'view' ? 'Task Details' : modalTitle}</Title>

    {isWithoutRequest ?
      null :
      <RequestClients
        isShowContacts={isShowContacts}
        onToggleShowContacts={onToggleShowContacts}
        request={task.request}
      />
    }

    {type === 'view'
      ? <TaskDetails
        title={title}
        status={status}
        dueDate={dueDate}
        dueTime={dueTime}
        onClose={onClose}
        description={description}
        taskPriority={taskPriority}
        assignedTo={task.assignedTo}
      />
      :
      <TaskForm
        form={form}
        title={title}
        users={users}
        status={status}
        onSubmit={onSave}
        dueTime={dueTime}
        isUpdating={isUpdating}
        dueDate={moment(dueDate)}
        description={description}
        taskPriority={taskPriority}
        selectedUser={selectedUser}
        setRequestsData={setRequestsData}
        selectedRequest={selectedRequest}
        setSelectedUser={setSelectedUser}
        isWithoutRequest={isWithoutRequest}
        searchedRequests={searchedRequests}
        isFetchingRequests={isFetchingRequests}
        setSelectedRequest={setSelectedRequest}
        handleRequestSearch={handleRequestSearch}
        requestAssignees={task.request.assignees}
      />
    }
  </Fragment>
);


TasksModal.propTypes = {
  modalTitle: string.isRequired,
  isLoading: bool.isRequired,
  isUpdating: bool.isRequired,
  form: object.isRequired,
  task: object.isRequired,
  dueDate: string,
  dueTime: string,
  title: string,
  description: string.isRequired,
  taskPriority: string.isRequired,
  type: string,
  users: object,
  status: bool.isRequired,
  onSave: func.isRequired,
  onClose: func.isRequired,
  selectedUser: string,
  searchedRequests: array.isRequired,
  setSelectedUser: func.isRequired,
  isShowContacts: bool.isRequired,
  isWithoutRequest: bool,
  isFetchingRequests: bool.isRequired,
  setSelectedRequest: func.isRequired,
  setRequestsData: func.isRequired,
  handleRequestSearch: func.isRequired,
  onToggleShowContacts: func.isRequired,
  selectedRequest: oneOfType([object, array, string]),
};

TasksModal.defaultProps = {
  title: '',
  type: '',
  users: {},
  dueDate: undefined,
  dueTime: undefined,
  selectedUser: undefined,
  isWithoutRequest: false,
  selectedRequest: undefined,
};



// WEBPACK FOOTER //
// ./src/modals/tasks-modal/component.js